<template>
    <div class="max-w-2xl px-4 py-8 mx-auto sm:py-8 sm:px-6 lg:max-w-7xl lg:px-8">

        <div v-if="productsRetrieved === true">
            <div v-if="products"
                 class="grid grid-cols-2 gap-y-4 sm:grid-cols-3 gap-x-6 sm:gap-y-10 lg:grid-cols-3 lg:gap-x-8">
                <div v-for="product in products" :key="product.asin"
                     class="relative flex flex-col overflow-hidden bg-white border border-gray-200 rounded-lg group">
                    <div class="bg-gray-200 group-hover:opacity-75 aspect-square">
                        <img :alt="product.coverUrl" :src="product.coverUrl"
                             class="object-cover mx-auto sm:w-full aspect-square rounded-2xl max-w-80 w-full"/>
                    </div>
                    <div class="flex flex-col flex-1 p-4 space-y-2">
                        <h3 class="text-sm font-medium text-gray-900">
                            <a :href="product.itemUrl">
                                <span aria-hidden="true" class="absolute inset-0"/>
                                {{ product.productGroup }}
                            </a>
                        </h3>
                        <p class="text-sm text-clay-800">{{ product.title }}</p>
                        <div class="flex flex-col justify-end flex-1">
                            <p class="text-base font-medium text-gray-900">{{ product.price }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:grid-cols-3 lg:gap-x-8">
                <p>Sorry, we currently do not have any related products.</p>
            </div>
        </div>
        
        <SkeletonCard card-style="long" :num-of-cards=4 v-else/>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {defineComponent, onMounted, ref, Ref, defineProps} from "vue";
import {client} from '@/shared';
import {GetRelatedProductsFromAmazon, RelatedProductFromAmazonDto} from "@/dtos";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";

const props = defineProps({
  searchTerm: String
})
let searchTerm: Ref<String> = ref(props.searchTerm);
let products: Ref<Array<RelatedProductFromAmazonDto>> = ref(new Array<RelatedProductFromAmazonDto>());

const productsRetrieved = ref(false);

onMounted(async () => {
  await client.get<Array<RelatedProductFromAmazonDto>>(new GetRelatedProductsFromAmazon({title: searchTerm.value}))
      .then((res) => {
        products.value = res;
        productsRetrieved.value = true;
      })
});

</script>